function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

export const API_BASE_URL: string = trimTrailingSlash(
  import.meta.env.VITE_API_BASE_URL ?? "/api",
);
